import React from 'react';
import { compactMoney } from '../format';

export default function WealthGoalBody({ artifact, data }) {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <span className="text-[28px] font-light tracking-[-0.02em] tabular-nums">{compactMoney(data.goal)}</span>
        <span className="text-[14px] text-muted-foreground">
          {data.annual_income_needed ? `${compactMoney(data.annual_income_needed)} a year in retirement` : 'Your lump-sum goal'}
          {data.years_to_exit ? ` · in about ${data.years_to_exit} years` : ''}
        </span>
      </div>
      <span className="text-[14px] text-foreground/[0.88]">
        Savings and investments outside the business today: {compactMoney(data.current_investable_assets)}
      </span>
      {artifact.summary && <p className="m-0 text-[15px] leading-[1.6] text-foreground/[0.88]">{artifact.summary}</p>}
    </div>
  );
}
